// 与 waiqinfengweb / 小程序保持一致
export const HOST =
  process.env.NODE_ENV === 'development'
    ? 'https://cs.jialebi.net'
    : 'https://app.jialebi.net'

const isDev = process.env.NODE_ENV === 'development'

// Field_bee 业务接口（开发走本地代理，避免跨域）
export const BASE_URL = isDev ? '/api' : `${HOST}/api`

// shopro 支付接口（实际可调通: /addons/shopro/pay/prepay）
export const SHOPRO_API_URL = isDev ? '/addons/shopro/' : `${HOST}/addons/shopro/`

// 支付结果页域名（须与微信商户/小程序已配置域名一致；yhp 已验证可调通）
export const PAY_H5_DOMAIN = 'https://yhp.jialebi.net/'

// 外勤蜂实时聊天 WebSocket（与小程序 env.js 一致）
export const WEBSOCKET_URL = 'wss://cs.jialebi.net:1818'
